<div style="display: flex; justify-content: end">
  <app-countable-button [count]="orderCount" [matMenuTriggerFor]="more">
    <mat-label>{{ 'ORDERS.ACTIONS.title' | translate }}</mat-label>
  </app-countable-button>

  <mat-menu #more="matMenu" [overlapTrigger]="false" xPosition="before">
    <ng-template matMenuContent>
      <a [project-route]="['grouped-status-change']" mat-menu-item>
        <mat-label>{{ 'ORDERS.ACTIONS.bulk_status' | translate }}</mat-label>
      </a>

      <button [disabled]="disable" [matMenuTriggerFor]="changeStatus" mat-menu-item>
        <mat-icon>multiline_chart</mat-icon>
        <mat-label>{{ 'ORDERS.COMMON.STATUS_BUTTON.change_status' | translate }}</mat-label>
      </button>

      <button [disabled]="disable" [matMenuTriggerFor]="unloading" mat-menu-item>
        <mat-icon>local_shipping</mat-icon>
        <mat-label>{{ 'ORDERS.COMMON.UNLOADING_BUTTON.unloading_button' | translate }}</mat-label>
      </button>

      <button [disabled]="disable" [matMenuTriggerFor]="print" mat-menu-item>
        <mat-icon>print</mat-icon>
        <mat-label>{{ 'ORDERS.COMMON.PRINTING_BUTTON.printing_button' | translate }}</mat-label>
      </button>

      <button [disabled]="disable" [matMenuTriggerFor]="summary" mat-menu-item>
        <mat-icon>view_list</mat-icon>
        <mat-label>{{ 'ORDERS.ACTIONS.summary' | translate }}</mat-label>
      </button>

      <button [matMenuTriggerFor]="tracks" [disabled]="disable" mat-menu-item>
        <mat-icon>replay</mat-icon>
        <mat-label>{{ 'ORDERS.ACTIONS.resend' | translate }}</mat-label>
      </button>

      <button (click)="cancelUnloading()" [disabled]="disable" mat-menu-item>
        <mat-icon>redo</mat-icon>
        <mat-label>{{ 'ORDERS.ACTIONS.cancel_export' | translate }}</mat-label>
      </button>
      <button (click)="copyFilter()" *isDev mat-menu-item>
        <mat-icon>content_copy</mat-icon>
        <mat-label>{{ 'ORDERS.ACTIONS.copy_criteria' | translate }}</mat-label>
      </button>

      <button (click)="showCode()" *isDev mat-menu-item>
        <mat-icon>code</mat-icon>
        <mat-label>{{ 'ORDERS.ACTIONS.show_code' | translate }}</mat-label>
      </button>
    </ng-template>
  </mat-menu>
</div>

<mat-menu #changeStatus [overlapTrigger]="false" xPosition="before">
  <ng-template matMenuContent>
    @if (statusChains$ | async; as statusChains) {
      @if (statusChains.length) {
        <mat-optgroup [label]="'ORDERS.COMMON.STATUS_BUTTON.status_chains_label' | translate">
          @for (statusChain of statusChains; track trackById($index, statusChain)) {
            <mat-option (click)="onStatusChainClicked(statusChain)"
              >
              {{ statusChain.name }}
            </mat-option>
          }
        </mat-optgroup>
      }
    }
    @for (pair of statusGroups$ | async; track trackByStatusGroup($index, pair)) {
      <mat-optgroup
        [label]="pair.group | label:'order-states' | async">
        @for (status of pair.statuses; track trackById($index, status)) {
          <mat-option (click)="onStatusClicked(status)"
            >
            {{ status.name }}
          </mat-option>
        }
      </mat-optgroup>
    }
  </ng-template>
</mat-menu>

<mat-menu #unloading="matMenu" [overlapTrigger]="false" xPosition="before">
  <ng-template matMenuContent>
    @if (courierChains$ | async; as courierChains) {
      @if (courierChains.length) {
        <mat-optgroup [label]="'ORDERS.COMMON.UNLOADING_BUTTON.chains_group' | translate">
          @for (chain of courierChains; track chain) {
            <mat-option (click)="onCourierChainClicked(chain)"
              [matTooltip]="chain.name">
              {{ chain.name }}
            </mat-option>
          }
        </mat-optgroup>
        <mat-divider></mat-divider>
      }
    }
    <mat-optgroup [label]="'ORDERS.COMMON.UNLOADING_BUTTON.courier_group' | translate">
      @for (courier of couriers$ | async; track trackById($index, courier)) {
        <mat-option (click)="onCourierClicked(courier)"
          [matTooltip]="courier.name">
          {{ courier.name }}
        </mat-option>
      }
    </mat-optgroup>
  </ng-template>
</mat-menu>

<mat-menu #print="matMenu" [overlapTrigger]="false" xPosition="before">
  <ng-template matMenuContent>
    @if (pools$ | async; as pools) {
      @if (pools.length) {
        <mat-optgroup [label]="'ORDERS.COMMON.PRINTING_BUTTON.pools_group' | translate">
          @for (pool of pools; track pool) {
            <mat-option (click)="onPoolPrinting(pool)" [matTooltip]="pool.name">
              {{ pool.name }}
            </mat-option>
          }
        </mat-optgroup>
        <mat-divider></mat-divider>
      }
    }
    @for (pair of documentGroups$ | async; track trackByDocumentGroup($index, pair)) {
      <mat-optgroup [label]="pair.additional ? ('ORDERS.COMMON.PRINTING_BUTTON.additional_group' | translate) : pair.group">
        @for (document of pair.documents; track trackById($index, document)) {
          <mat-option (onSelectionChange)="onSinglePrinting(document)"
            [matTooltip]="document.name">
            {{ document.name }}
          </mat-option>
        }
      </mat-optgroup>
    }
  </ng-template>
</mat-menu>

<mat-menu #summary="matMenu" [overlapTrigger]="false" xPosition="before">
  <ng-template matMenuContent>
    @for (summary of summary$ | async; track summary) {
      <mat-option
        (click)="openSummaryDialog(summary.id)">
        {{ summary.name }}
      </mat-option>
    }
  </ng-template>
</mat-menu>

<mat-menu #tracks="matMenu" [overlapTrigger]="false" xPosition="before">
  <ng-template matMenuContent>
    <mat-option (click)="resendTracks(filter)">{{ 'ORDERS.ACTIONS.resend_tracks' | translate }}</mat-option>
    <mat-option (click)="resendStatuses(filter)">{{ 'ORDERS.ACTIONS.resend_statuses' | translate }}</mat-option>
  </ng-template>
</mat-menu>
